const EmptySearchResult = ({ prevQuery }: { prevQuery: string }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full py-[200px] gap-[10px]">
      <div className="flex items-center justify-center">
        <img src="/icons/ui/search-magnifier.svg" alt="search-tag-empty" />
      </div>
      <div className="body-1-normal-medium">
        {prevQuery.length > 0 ? (
          <div className="flex flex-col items-center gap-[8px]">
            <span className="text-neutral-600 text-center body-1-normal-semibold">
              앗, 일치하는 결과가 없어요.
            </span>
            <span className="text-neutral-600 text-center body-1-normal-medium">
              다른 검색어를 입력해 보세요.
            </span>
          </div>
        ) : (
          <span className="text-neutral-600 text-center body-1-normal-medium">
            검색을 통해 원하는 구성요소를 찾아보세요
          </span>
        )}
      </div>
    </div>
  );
};

export default EmptySearchResult;
